export default __webpack_public_path__ + "7922c90d38680caf469f57705551ba62.jpg";